export function ReceiveOutline({ className = '' }: Readonly<{ className?: string }>) {
  return (
    <span className={`icon ${className}`}>
      <svg
        width="1em"
        height="1em"
        viewBox="0 0 23 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M11.75 1.83301V7.33301M11.75 7.33301L13.5833 5.49967M11.75 7.33301L9.91667 5.49967M5.33333 10.9997V7.33301C5.33333 5.49051 5.33333 3.96884 8.08333 3.70301M18.1667 10.9997V7.33301C18.1667 5.49051 18.1667 3.96884 15.4167 3.70301M7.16667 10.9997C3.5 10.9997 3.5 12.6405 3.5 14.6663V15.583C3.5 18.113 3.5 20.1663 8.08333 20.1663H15.4167C19.0833 20.1663 20 18.113 20 15.583V14.6663C20 12.6405 20 10.9997 16.3333 10.9997C15.4167 10.9997 15.16 11.1922 14.6833 11.5497L13.7483 12.5397C12.6667 13.6947 10.8333 13.6947 9.7425 12.5397L8.81667 11.5497C8.34 11.1922 8.08333 10.9997 7.16667 10.9997Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </span>
  );
}
